import { LinearGradient } from 'expo-linear-gradient'
import { TouchableOpacity, ViewStyle } from 'react-native'

import { DS } from '../../design-system'
import { styles } from './styles'

interface GradientButtonProps {
  title: string
  onPress: () => void
  contentContainerStyle?: ViewStyle
  gradientColorArray?: [string, string, ...string[]]
}

export const GradientButton = (props: GradientButtonProps) => {
  const { title, onPress, contentContainerStyle, gradientColorArray = ['#A3007F', '#480D93'] } = props
  return (
    <LinearGradient
      colors={gradientColorArray}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={[styles.submitGradientButton, contentContainerStyle]}
    >
      <TouchableOpacity style={styles.submitButton} onPress={onPress}>
        <DS.Text variant="Body Medium/Medium" color="Global/White" textAlign="center">
          {title}
        </DS.Text>
      </TouchableOpacity>
    </LinearGradient>
  )
}
